import { radioButtonValues } from 'context';
import Logger from 'js-logger';
import { HTTP_POST } from 'utils/constants/constants';
import { wampCall } from 'utils/initUtils';

export const CREATE_MEETING_ENDPOINT = 'lifesize.meeting';
export const CREATE_MEETING_URI = 'meeting/create';

export interface CreateMeetingObj {
  meetingType: string;
  oneTimeName: string;
  oneTimeModerator: any;
  oneTimePasscode?: string;
  ownerExtension: string;
}

export const createMeeting = async ({
  meetingType,
  oneTimeName,
  oneTimeModerator,
  oneTimePasscode,
  ownerExtension
}: CreateMeetingObj) => {
  Logger.info(`[wamp-connection checkin] Create Meeting starting`);
  const oneTimeMeeting = meetingType === radioButtonValues.oneTime;
  const inputParams = {
    displayName: oneTimeName,
    description: '',
    ownerExtension,
    moderatorExtension: oneTimeModerator.extension,
    pin: oneTimePasscode,
    tempMeeting: oneTimeMeeting
  };
  const callParams = {
    procedure: CREATE_MEETING_ENDPOINT,
    args: [
      JSON.stringify({
        uriSuffix: CREATE_MEETING_URI,
        httpMethod: HTTP_POST,
        inputParams,
        queryParams: null
      })
    ]
  };
  try {
    const meetingCreationResponse = await wampCall(callParams);
    const parsedResponse = JSON.parse(meetingCreationResponse);

    // check status code of response
    if (!parsedResponse.statusCode || parsedResponse.statusCode >= 400) {
      throw parsedResponse;
    }

    Logger.log(`[wamp-connection checkin] Create Meeting success`);
    return parsedResponse.body;
  } catch (error) {
    Logger.log(`[wamp-connection checkin] checkin error`, error);
    throw error;
  }
};

export const isDirectMeeting = (meetingType: radioButtonValues) => meetingType === radioButtonValues.direct;

export const isOneTimeMeeting = (meetingType: radioButtonValues) => meetingType === radioButtonValues.oneTime;

export const isExistingMeeting = (meetingType: radioButtonValues) => meetingType === radioButtonValues.find;

export const isRoomSystem = (meetingType: radioButtonValues) => meetingType === radioButtonValues.findRoom;
